import React from 'react';
import Wizards from './components/Wizard';

export default [
    {
        path: '/wizard',
        exact: true,
        component: () => <Wizards />
    },
];